import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-end-fundraiser-banner',
  templateUrl: './end-fundraiser-banner.component.html',
  styleUrls: ['./end-fundraiser-banner.component.scss']
})
export class EndFundraiserBannerComponent implements OnInit {

  @Input() fundraiser;
  @Input() isFundraiserEnded;
  @Input() isSuccessfullyFunded;
  @Input() sharedCounts;
  @Input() basicInfo;
  @Input() campaignUrl;
  constructor() { }

  ngOnInit() {
  }

}
